export const SERVICES = [
  {
    id: "screen",
    num: "01",
    title: "Broken screen repair",
    icon: "crack",
    blurb:
      "Cracked glass, dead pixels, lines across the display or a touch layer that stopped listening. We replace screens on phones, tablets and laptops with quality-matched parts.",
    symptoms: ["Cracked or shattered glass", "Touch not responding", "Lines, spots or black areas", "Screen stays black but phone vibrates"],
  },
  {
    id: "battery",
    num: "02",
    title: "Battery replacement",
    icon: "battery",
    blurb:
      "If your phone dies at 30%, shuts down in the cold or needs a charger all day, a fresh battery usually brings it back. Health checked before and after.",
    symptoms: ["Battery drains within hours", "Random shutdowns", "Swollen battery pushing the screen up", "Only works while plugged in"],
  },
  {
    id: "charging",
    num: "03",
    title: "Charging-port & power problems",
    icon: "plug",
    blurb:
      "Loose cables, slow charging or a phone that only charges at one angle. We clean, repair or replace charging ports and trace power issues to the board when needed.",
    symptoms: ["Cable feels loose or falls out", "Charges only at a certain angle", "No charging at all", "Wireless charging works but the port does not"],
  },
  {
    id: "backglass",
    num: "04",
    title: "Back glass & housing damage",
    icon: "layers",
    blurb:
      "Cracked rear glass and bent frames are more than cosmetic — they let dust and moisture in. We replace back glass and restore housings so the device is sealed again.",
    symptoms: ["Cracked or shattered rear glass", "Sharp edges when holding the phone", "Bent or dented frame", "Camera ring loose or rattling"],
  },
  {
    id: "camera",
    num: "05",
    title: "Camera replacement & repair",
    icon: "camera",
    blurb:
      "Blurry photos, a shaking lens, focus hunting or a camera app that opens to black. We replace lens glass and camera modules front and rear.",
    symptoms: ["Photos always blurry", "Camera shakes or rattles", "Black screen in the camera app", "Cracked lens glass"],
  },
  {
    id: "water",
    num: "06",
    title: "Water damage assessment",
    icon: "droplets",
    blurb:
      "Liquid inside a device is a race against corrosion. Bring it in powered off — we open it, clean corrosion and assess what can be saved before quoting any work.",
    symptoms: ["Dropped in water or spilled on", "Screen flickering after getting wet", "Phone died after liquid exposure", "Moisture visible under the camera or screen"],
  },
  {
    id: "software",
    num: "07",
    title: "Software, crashes & boot problems",
    icon: "refresh",
    blurb:
      "Stuck on the logo, failed updates, constant crashes or account lockouts. We sort software problems, restore systems and help you get back into your device.",
    symptoms: ["Stuck on the startup logo", "Update failed and device won't boot", "Apps crashing constantly", "Locked out of accounts or device"],
  },
  {
    id: "data",
    num: "08",
    title: "Data recovery & device access",
    icon: "harddrive",
    blurb:
      "Photos, contacts and files trapped on a dead or damaged device. We recover data from phones and laptops whenever the hardware allows it — even when the device itself won't turn on.",
    symptoms: ["Device won't turn on but data matters", "Photos or files trapped on a broken phone", "Forgotten passcode situations", "Failing laptop drive"],
  },
  {
    id: "laptop",
    num: "09",
    title: "Laptop hardware & software support",
    icon: "laptop",
    blurb:
      "Screens, keyboards, batteries, storage upgrades, slow systems and malware cleanups — MacBook and Windows laptops get the same careful bench treatment as phones.",
    symptoms: ["Cracked laptop screen", "Keyboard keys dead or typing wrong", "Laptop suddenly very slow", "Won't charge or hold a charge"],
  },
  {
    id: "diagnostics",
    num: "10",
    icon: "search",
  },
  {
    id: "cleaning",
    num: "11",
    icon: "sparkles",
  },
];
